import {View} from 'MWC';
import mainTpl from '../../templates/order/kun';

class OrderKUN extends View {
    template = mainTpl;

    static displayName = 'Cards.Views.OrderKUN';
}

export default OrderKUN;
